import React from 'react'
import AreaDetailsContainer from '../../modules/AreaManagement/containers/AreaDetailsContainer/AreaDetailsContainer'

const AreaDetails = () => {
  return (
    <AreaDetailsContainer />
  )
}

export default AreaDetails